import { ImageRefsSlot, type ImageRefs } from "../../../platform/media/ImageRefsSlot";
import classes from "../../../platform/media/slots.module.css";
import { ElementsSlot, type ElementsProps } from "../video/ElementsSlot";
import type { MediaRefs } from "../video/MediaRefsSlot";
import { VideoRefSlot } from "../video/VideoRefSlot";

export interface ToolSlotsProps {
  /** The elements, where the tool's block takes them; else no slot. */
  elements: ElementsProps | undefined;
  /** The reference images, where the tool's block takes them; else no slot. */
  refs: ImageRefs | undefined;
  /** The video the tool works on: live's "Video ref", one video. */
  video: MediaRefs;
  /** Its reference videos, where the tool's block takes them (Kling 4.0 Edit); else no slot. */
  videos?: MediaRefs | undefined;
}

/**
 * The slots of a tool that runs on the composer (#209, capture 04), in live's order: Elements,
 * Image refs and Video ref, each where the model's block takes it, with no frames and no swap;
 * then its reference videos, "Video refs", where the block takes them (no live tile: spec
 * web/edit-reference-videos).
 */
export function ToolSlots({ elements, refs, video, videos }: ToolSlotsProps) {
  return (
    <div className={classes.slots} data-slots>
      {elements === undefined ? null : <ElementsSlot elements={elements} />}
      {refs === undefined ? null : <ImageRefsSlot refs={refs} />}
      <VideoRefSlot refs={video} />
      {videos === undefined ? null : <VideoRefSlot refs={videos} label="Video refs" />}
    </div>
  );
}
